import { useEffect, useRef } from 'react';

import mapKeys from 'lodash/mapKeys';

import { getTokens, names } from './utils';

window.dataLayer = window.dataLayer || [];
export function useGAMetricSearch({
  searchQuery,
  favouriteMetrics,
  favouriteMetricFilters,
}) {
  const favouriteMetricFiltersRef = useRef();
  favouriteMetricFiltersRef.current = favouriteMetricFilters;
  useEffect(() => {
    if (searchQuery && favouriteMetrics?.length) {
      // window.dataLayer.push

      const searchTokens = getTokens(searchQuery, {
        favouriteMetrics: names(favouriteMetrics),
      });

      const metricsKey = names(favouriteMetrics);

      let favoriteMetric = '';
      let filters = {};
      let unknown = '';

      searchTokens?.forEach((token) => {
        let isUnknown = true;

        if (metricsKey.includes(token)) {
          favoriteMetric = token;
          isUnknown = false;
        } else {
          favouriteMetricFiltersRef?.current?.forEach(({ name, elements }) => {
            const filtersKey = names(elements);
            if (filtersKey.includes(token)) {
              isUnknown = false;
              filters[name] = filters[name]
                ? `${filters[name]} ${token}`
                : token;
            }
          });
        }

        if (isUnknown) {
          unknown = unknown ? `${unknown} ${token}` : token;
        }
      });

      const eventConfig = {
        event: 'metricSearch',
        searchQuery: searchQuery,
        ...mapKeys(filters, (_, k) => getParam(k)),
      };

      if (favoriteMetric) {
        eventConfig.metricSearchFavoriteMetric = favoriteMetric;
      }
      if (unknown) {
        eventConfig.metricSearchUnknown = unknown;
      }

      window.dataLayer.push(eventConfig);
    }
  }, [searchQuery, favouriteMetrics, favouriteMetricFiltersRef]);
}

export function getParam(label) {
  return `metricSearch${label
    .split(/\s+/)
    .map((s) => `${s.charAt(0).toUpperCase()}${s.slice(1)}`)
    .join('')}`;
}
